import React,{useEffect,useState} from "react";
import "./CardBlog.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import CardBox from "./CardBox";
import { Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import axios from "axios"
import {Spinner} from "react-bootstrap"

function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  }
  return text;
}

let defaultBlogObj=[]

function CardTestimonial() {


  const [blogs, setBlogs] = useState([]);
  const [recentBlogs, setRecentBlogs] = useState([]);

  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  let blogAPICalled = false;

  useEffect(() => {
    getAllBlogsListing();
  }, []);

  const getAllBlogsListing = () => {
    if (blogAPICalled) return;
    blogAPICalled = true;

    setLoading(true);
    axios
      .get("/blogs", {})
      .then((res) => {
        if (res.data.status === "success") {
          let Updated_data_Blogs = [];
          let Updated_recent_blogs = [];
          res.data.data.forEach((item) => {
            Updated_data_Blogs.push({
              id: item.blog_id,
              main_heading: item.title,
              paragraph: item.brief_paragraph,
              logo: "/favicon.png",
              entity: "Creative Squad",
              date: item.published_date,
              slug_url: item.slug_url,
              category: item.category,
              blog_creative: item.blog_image,
            });
          });
          res.data.data.forEach((item) => {
            Updated_recent_blogs.push({
              id: item.blog_id,
              slug_url: item.slug_url,
              logo: item.blog_image,
              blog_description: item.title,
              date: item.published_date,
            });
          });
          setRecentBlogs(Updated_recent_blogs.slice(0, 3));
          setBlogs(Updated_data_Blogs);
          if(blogs.length <= 3)
          {
            setBlogs((prev)=>[...prev,...prev])
          }
          defaultBlogObj = Updated_data_Blogs;
          setLoading(false);
        }
          
      })
      .catch((err) => {
        console.log("eror =>",err);
        setLoading(false);
      });
  };

  const convertToSlug = (str) => {
    return str.toLowerCase().replace(/\s+/g, "-");
  };

  const redirectUserToBlog = (id) => {
    if (!id) return;
    let slug = convertToSlug(id);

    navigate(`/blogs/${slug}`);
  };



  return (
    <div className='CardTestimonial-container '>
      <div className="container">

        <div className="testimonial-text-content ">
          <p className="sub-heading">OUR BLOGS</p>
          <h3 className="body-heading">Latest <span className="color-yellow">News & Updates</span></h3>   
        </div>
        {loading ? 
        (<div className="w-100 text-center mb-5">
          <Spinner
            style={{ color: "#DB831C", width: "120px", height: "120px" }}
          />
        </div>):
          (
            <>
        <Swiper
            spaceBetween={50}
            breakpoints={{
                280: {
                  slidesPerView: 1,
                },
                992: {
                  slidesPerView: 3,
                }
              }}
            loop={true}
            autoplay={
              {
                delay:1500,
                disableOnInteraction:false
              }
            }
            modules={[Autoplay]}
            className="card-list"
            >
            {blogs.map((blogData,ind)=>{
              return (<>
                <SwiperSlide key={ind}>
                  <CardBox 
                    cardImg={blogData.blog_creative} 
                    title={blogData.main_heading} 
                    content={blogData.paragraph} 
                    anchor={blogData.slug_url}
                    redirectionFunction={redirectUserToBlog}
                    />
                </SwiperSlide>
              </>)
            })}
            
        </Swiper>
        <div className="btn-container d-flex align-items-center justify-content-center">
          <button className="genral-btn" onClick={()=>{navigate("/blog")}}>Read All</button>
        </div>
        </>)}
      </div>
    </div>
  )
}

export default CardTestimonial